import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '../lib/api';
import { useAuth } from '../context/AuthContext.jsx';

export const NOTIFICATIONS_KEY = ['me', 'notifications'];

/** Unread count for the bell — polled, and refreshed when the app regains focus. */
export function useUnreadCount() {
  const { user } = useAuth();
  const q = useQuery({
    queryKey: [...NOTIFICATIONS_KEY, 'unread'],
    queryFn: () => api.get('/api/me/notifications/unread-count'),
    enabled: Boolean(user),
    refetchInterval: 45_000,
    refetchOnWindowFocus: true,
  });
  return q.data?.unread ?? 0;
}

export function useNotifications() {
  const { user } = useAuth();
  return useQuery({
    queryKey: [...NOTIFICATIONS_KEY, 'list'],
    queryFn: () => api.get('/api/me/notifications?limit=50'),
    enabled: Boolean(user),
    refetchInterval: 45_000,
    refetchOnWindowFocus: true,
  });
}

/** Mark some ids read, or everything when called with no ids. */
export function useMarkRead() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (ids) => api.post('/api/me/notifications/read', ids?.length ? { ids } : {}),
    onSuccess: () => qc.invalidateQueries({ queryKey: NOTIFICATIONS_KEY }),
  });
}
